import { fromJS } from 'immutable'
import {
  ACCOUNTING_BILLING_EXPORT_REQUEST,
  ACCOUNTING_BILLING_EXPORT_SUCCESS,
  ACCOUNTING_BILLING_EXPORT_FAILURE,
  ACCOUNTING_BILLING_EXPORT_RESET,
} from '../../actions/accounting-dashboard/types'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case ACCOUNTING_BILLING_EXPORT_REQUEST:
      return state
        .set('isFetching', true)
    case ACCOUNTING_BILLING_EXPORT_SUCCESS:
      return state
        .set('url', fromJS(action.payload.url))
        .set('isFetching', false)
    case ACCOUNTING_BILLING_EXPORT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case ACCOUNTING_BILLING_EXPORT_RESET:
      return state
        .delete('url')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/accounting-dashboard/billing-export-reducer.js